// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"204":"b39dbd97004bc4b5","497":"edf57dce997805c5"}[chunkId] + ".css";
};